import { default as Captcha } from './captcha';
const install = (app) => {
    app.use(Captcha);
    return app;
};
export { Captcha };
export default {
    version: '2.0.1',
    install
};
